// @ts-check

import { combineReducers } from "redux";
import buildingInfoReducer from './FormBuildingInfo/buildingInfoReducer'
import costsReducer from './FormCosts/formCostsReducer'
import sustainabilityReducer from './FormSustainability/formSustainabilityReducer'
import validationReducer from './FormValidation/validationReducer'

export const globalFormReducer = combineReducers({
  buildingInfo: buildingInfoReducer,
  costs: costsReducer,
  sustainability: sustainabilityReducer,
  validation: validationReducer
});
